<template>
  <select-dict
    v-model="structureType"
    :selectList="props.list"
    :is-extra="true"
  />
</template>

<script setup lang="ts">
import { defineModel } from "vue";
import SelectDict from "@/components/UI/SelectDict.vue";

const props = defineProps(["list"]);
const structureType = defineModel<string>();
</script>

<style lang="scss" scoped></style>
